import { useApiQuery } from 'hooks/useApiQuery'

export const useGetSweepstakeByIdWithGroupDrawingInfo = ({
  sweepstakeId,
}: {
  sweepstakeId?: number
}) =>
  useApiQuery({
    path: '/le-connect/contests/{id}/drawing-info/multi-draw',
    method: 'get',
    queryKey: ['/sweepstakes/drawing-info/multi-draw', sweepstakeId],
    queryArgs: { id: sweepstakeId },
    enabled: sweepstakeId != null,
  })
